module.exports = __webpack_public_path__ + "static/img/logo3.b627fc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head/logo3.png
// module id = jwNE
// module chunks = 29